import { generatePath } from "react-router";
import { STEP_TYPES } from "src/api/Processes";

export enum Route {
    root = "/",
    start = "/start",
    process = "/process/:processId",
    step = "/process/:processId/:stepType/:stepId",
    realestate = "/realestate",
    register = "/register",
    contact = "/contact",
    select = "/process/:processId/:stepType/:stepId/",
    selectComponent = "/process/:processId/:stepType/:stepId/component/:componentId",
    service = "/service",
    serviceCode = "/service/?code=:code&type=:forwardingType",
    systemHealthError = "/system-health-error",
    logout = "/logout",
    portalUserInfoPage = "/user-info-page"
}

export const selectRoute = (route: Route, params?: { [key: string]: string }): string => {
    const searchPath = window.location.search;

    if (params) {
        return `${generatePath(route, params)}${searchPath ?? ""}`;
    } else {
        return `${route}${searchPath ?? ""}`;
    }
};
export const getRoute = (route: Route, params?: { [key: string]: string | number | STEP_TYPES }): string => {
    if (params) {
        let newRoute = String(route);
        for (let key in params) {
            newRoute = newRoute.replace(":" + key, String(params[key]));
        }
        return newRoute;
    } else {
        return route;
    }
};
